"use strict"

const initialState = {
    showSmallCharts: false,
    includeTableInPdf: false,
    showRangeSliders: false,
    startGraphFromZero: true,
    showCombinationCharts: false,
    showActivity: false,
    observationsFetchedChange: null,
}

const getters = {
    showSmallCharts: state => state.showSmallCharts,
    includeTableInPdf: state => state.includeTableInPdf,
    showRangeSliders: state => state.showRangeSliders,
    startGraphFromZero: state => state.startGraphFromZero,
    showCombinationCharts: state => state.showCombinationCharts,
    showActivity: state => state.showActivity,
    observationsFetchedChange: state => state.observationsFetchedChange,
}

const actions = {
    showChartsSmall({commit, state}, show) {
        commit('showChartsSmall', show)
    },
    includeTableInPdf({commit, state}, include) {
        commit('includeTableInPdf', include)
    },
    showRangeSliders({commit, state}, show) {
        commit('showRangeSliders', show)
    },
    startGraphFromZero({commit, state}, startFromZero) {
        commit('startGraphFromZero', startFromZero)
    },
    showCombinationCharts({commit, state}, showCombinationCharts) {
        commit('showCombinationCharts', showCombinationCharts)
    },
    showActivity({commit, state}, showActivity) {
        commit('showActivity', showActivity)
    },
    observationsFetchedChange({commit, state}, observationsFetchedChange) {
        commit('observationsFetchedChange', observationsFetchedChange)
    },
}

const mutations = {
    showChartsSmall(state, show) {
        state.showSmallCharts = show
    },
    includeTableInPdf(state, include) {
        state.includeTableInPdf = include
    },
    showRangeSliders(state, include) {
        state.showRangeSliders = include
    },
    startGraphFromZero(state, startFromZero) {
        state.startGraphFromZero = startFromZero
    },
    showCombinationCharts(state, showCombinationCharts) {
        state.showCombinationCharts = showCombinationCharts
    },
    showActivity(state, showActivity) {
        state.showActivity = showActivity
    },
    observationsFetchedChange(state, observationsFetchedChange) {
        state.observationsFetchedChange = observationsFetchedChange
    },
}

export default {
    state: {...initialState},
    getters,
    actions,
    mutations
}




// WEBPACK FOOTER //
// ./src/app/store/modules/settings.js